// S27: Error 404 - Page Not Found
import { Result, Button } from 'antd';
import { FileSearchOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export function Error404() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
      }}
    >
      <Result
        status="404"
        icon={<FileSearchOutlined style={{ fontSize: '72px' }} />}
        title="Page not found"
        subTitle="The page you're looking for doesn't exist or may have moved."
        extra={
          <Button
            type="primary"
            size="large"
            icon={<HomeOutlined />}
            onClick={() => navigate('/')}
          >
            Go to Dashboard
          </Button>
        }
      />
    </div>
  );
}
